<p>thread-file-upload-display works!</p>
<p>{{ fileName }}</p>
<div
  *ngIf="tempImage"
  [style.backgroundImage]="'url(' + tempImage + ')'"
  class="media-style"
></div>
<mat-progress-bar
  [mode]="progressMode"
  [value]="progressValue"
></mat-progress-bar>
<button mat-icon-button (click)="clickCancel()">
  <mat-icon> highlight_off </mat-icon>
</button>
<p *ngIf="showError">Error</p>
